import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Ping first-party du clic puis redirection manuelle (pattern InfoFlow).
 * Fire-and-forget : la navigation ne doit jamais attendre le ping.
 */
export function trackAdClick(adId, { itemType, itemId } = {}) {
  const body = {};
  if (itemType) body.item_type = itemType;
  if (itemId) body.item_id = itemId;
  try {
    // beacon quand dispo (navigation cross-domain) sinon axios fire-and-forget.
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
      navigator.sendBeacon(`${API_URL}/api/ads/${adId}/click`, blob);
      return;
    }
  } catch { /* ignore */ }
  axios.post(`${API_URL}/api/ads/${adId}/click`, body).catch(() => {});
}
